export const mediumDateFormatter = new Intl.DateTimeFormat([], {
    dateStyle: 'medium',
    timeZone: 'UTC',
} as any)
